enum PriorityLevels {
  none = 0,
  recommended = 1,
  important = 2,
  required = 3,
}

export default PriorityLevels;
